import { Box, Button, Flex, Heading, Icon, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import UIWidth from '../UIWidth';

export default function TextBanner({
  title,
  text,
  button,
  accentColor,
  picto,
}) {
  return (
    <Box
      width="100%"
      background={accentColor}
      py={['2rem', '5rem']}
      position="relative"
    >
      <UIWidth>
        <Flex
          direction="column"
          textAlign="center"
          justify="center"
          align="center"
          gap={['1.25rem', '', '2rem']}
          position="relative"
          zIndex="1"
        >
          <Heading as="h2" variant="h2" color="inherit">
            {title}
          </Heading>
          <Text fontSize={['1rem', '', '1.25rem']} dangerouslySetInnerHTML={{__html: text}}></Text>
          {button}
        </Flex>

        <Box
          display={['none', 'block']}
          opacity="15%"
          position="absolute"
          top="50%"
          left="0"
          transform="translateY(-50%)"
        >
          {picto}
        </Box>
      </UIWidth>
    </Box>
  );
}
